import { Injectable } from '@angular/core';
import { CallApiService } from 'src/app/core/service/call-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  constructor(
    private callAPI: CallApiService
  ) { }

  patientLogin(formData) {
    return this.callAPI._postAPI('/patient/login', formData)
  }
  socialPatientLogin(formData) {
    return this.callAPI._postAPI('/patient/login-social', formData)
  }
  socialDoctorLogin(formData) {
    return this.callAPI._postAPI('/doctor/login-social', formData)
  }
  socialHospitalLogin(formData) {
    return this.callAPI._postAPI('/hospital/login-social', formData)
  }
  doctorLogin(formData) {
    return this.callAPI._postAPI('/doctor/login', formData)
  }
  hospitalLogin(formData) {
    return this.callAPI._postAPI('/hospital/login', formData)
  }
  patientRegistration(formData) {
    return this.callAPI._postAPI('/patient/registration', formData)
  }
  doctorRegistration(formData) {
    return this.callAPI._postAPI('/doctor/registration', formData)
  }
  hospitalRegistration(formData) {
    return this.callAPI._postAPI('/hospital/registration', formData)
  }
  adminLogin(formData) {
    return this.callAPI._postAPI('/admin/login', formData)
  }
  pharmacyLogin(formData) {
    return this.callAPI._postAPI('/pharmacy/login', formData)
  }
  // drugstoreLogin(formData) {
  //   return this.callAPI._postAPI('/pharmacy/login', formData)
  // }
  forget_password(formData) {
    return this.callAPI._postAPI('/pharmacy/forgot-password', formData)
  }
  doctor_registration_number(formData) {
    return this.callAPI._postAPI('/doctor/update-registration-number', formData)
  }
  otp_send(formData) {
    return this.callAPI._postAPI('/user/validate-otp', formData)
  }
  otp_resend(formData) {
    return this.callAPI._postAPI('/user/resend-otp', formData)
  }
}
